export default {
  'app.true': 'YES',
  'app.false': 'NO',
  'app.403.page': 'No permission',
  'app.403.page.tip': 'Please contact admin for permission',
};
